module.exports = __webpack_public_path__ + "img/9788997980680.9069af17.jpg";